var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_9383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 0H5.6875C2.5515 0 0 2.5515 0 5.6875V22.3125C0 25.4485 2.5515 28 5.6875 28H22.3125C25.4485 28 28 25.4485 28 22.3125V5.6875C28 2.5515 25.4485 0 22.3125 0ZM27.125 22.3125C27.125 24.9659 24.9659 27.125 22.3125 27.125H5.6875C3.03406 27.125 0.875 24.9659 0.875 22.3125V5.6875C0.875 3.03406 3.03406 0.875 5.6875 0.875H22.3125C24.9659 0.875 27.125 3.03406 27.125 5.6875V22.3125Z",
    fill: "#FFD2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 2.625H7.875C4.98006 2.625 2.625 4.98006 2.625 7.875V20.125C2.625 23.0199 4.98006 25.375 7.875 25.375H20.125C23.0199 25.375 25.375 23.0199 25.375 20.125V7.875C25.375 4.98006 23.0199 2.625 20.125 2.625ZM24.5 20.125C24.5 22.5374 22.5374 24.5 20.125 24.5H7.875C5.46263 24.5 3.5 22.5374 3.5 20.125V7.875C3.5 5.46263 5.46263 3.5 7.875 3.5H20.125C22.5374 3.5 24.5 5.46263 24.5 7.875V20.125Z",
    fill: "#FFD2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.5625C9.89888 6.5625 6.5625 9.89888 6.5625 14C6.5625 18.1011 9.89888 21.4375 14 21.4375C18.1011 21.4375 21.4375 18.1011 21.4375 14C21.4375 9.89888 18.1011 6.5625 14 6.5625ZM14 20.5625C10.3814 20.5625 7.4375 17.6186 7.4375 14C7.4375 10.3814 10.3814 7.4375 14 7.4375C17.6186 7.4375 20.5625 10.3814 20.5625 14C20.5625 17.6186 17.6186 20.5625 14 20.5625Z",
    fill: "#FFD2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8.75C11.1051 8.75 8.75 11.1051 8.75 14C8.75 16.8949 11.1051 19.25 14 19.25C16.8949 19.25 19.25 16.8949 19.25 14C19.25 11.1051 16.8949 8.75 14 8.75ZM14 18.375C11.5876 18.375 9.625 16.4124 9.625 14C9.625 11.5876 11.5876 9.625 14 9.625C16.4124 9.625 18.375 11.5876 18.375 14C18.375 16.4124 16.4124 18.375 14 18.375Z",
    fill: "#FFD2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 4.8125C20.0349 4.8125 19.25 5.59737 19.25 6.5625C19.25 7.52763 20.0349 8.3125 21 8.3125C21.9651 8.3125 22.75 7.52763 22.75 6.5625C22.75 5.59737 21.9651 4.8125 21 4.8125ZM21 7.4375C20.5174 7.4375 20.125 7.04506 20.125 6.5625C20.125 6.07994 20.5174 5.6875 21 5.6875C21.4826 5.6875 21.875 6.07994 21.875 6.5625C21.875 7.04506 21.4826 7.4375 21 7.4375Z",
    fill: "#FFD2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 14H11.8125C11.8125 12.7938 12.7938 11.8125 14 11.8125V10.9375C12.3113 10.9375 10.9375 12.3113 10.9375 14Z",
    fill: "#FFD2A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_9383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/instaIcon.14afdc6005f2bc9440357e953d215ce7.svg";
export { ForwardRef as ReactComponent };